"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getSavingPercentage = function (product) {
    var _a, _b;
    if (!(((_a = product === null || product === void 0 ? void 0 : product.price) === null || _a === void 0 ? void 0 : _a.valueOld) && ((_b = product === null || product === void 0 ? void 0 : product.price) === null || _b === void 0 ? void 0 : _b.value)))
        return '';
    var savingValue = product.price.valueOld - (product.price.value || 0);
    // Flooring the saving instead of rounding so shown saving is never too high
    var savingPercentage = Math.floor((savingValue / product.price.valueOld) * 100);
    return savingPercentage > 1 ? "-" + savingPercentage + " %" : '';
};
exports.default = getSavingPercentage;
//# sourceMappingURL=getSavingPercentage.js.map